import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

class PestleHelpRows extends React.Component {

    static propTypes = {
        riskAngleMatches: PropTypes.object
    };

    static defaultProps = {
        riskAngleMatches: {
            political:     true,
            economic:      true,
            social:        true,
            technological: true,
            legal:         true,
            environmental: true
        }
    };

    render() {

        let pestle = Object.keys(this.props.riskAngleMatches);

        return (

            <span>
                {
                    pestle.map((pestle) => (
                        <div className={"row " + pestle} key={pestle}>
                            <div className="row-title">
                                <FormattedMessage id={"General_CoreFunctionality_UIText_general." + pestle} />
                            </div>
                            <div className="row-description">
                                <FormattedMessage id={"General_CoreFunctionality_UIText_general." + pestle + "Description" } />
                            </div>
                        </div>
                    ))
                }
            </span>
        )
    }

}

export default PestleHelpRows;


// WEBPACK FOOTER //
// ./src/scripts/reusable/PestleHelp/PestleHelp.Rows.jsx